module.exports = __webpack_public_path__ + "img/1517699481.59378b5a.jpg";